import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Header: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'sv' ? 'en' : 'sv');
  };

  const serviceLinks = [
    { to: '/services', label: t('services.title') },
    { to: '/horseltest', label: t('home.horseltest') },
    { to: '/horapparater', label: t('home.horapparater') },
    { to: '/service', label: t('home.service') },
    { to: '/arbetshjalpmedel', label: t('home.yrkesliv') },
    { to: '/horselskydd', label: t('home.horselskydd') },
  ];

  return (
    <header className="bg-[#0A4A7A] border-b border-[#083d66]">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="text-xl font-bold text-white">
            Värmdö Hörsel
          </Link>
          
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="text-white hover:text-gray-200 font-medium">{t('nav.home')}</Link>
            <div className="relative" onMouseEnter={() => setIsServicesOpen(true)} onMouseLeave={() => setIsServicesOpen(false)}>
              <button className="text-white hover:text-gray-200 font-medium">{t('nav.services')}</button>
              {isServicesOpen && (
                <div className="absolute left-0 mt-0 w-56 bg-white rounded-md shadow-lg z-50">
                  {serviceLinks.map(({ to, label }) => (
                    <Link key={to} to={to} className="block px-4 py-2 text-gray-700 hover:bg-gray-100">{label}</Link>
                  ))}
                </div>
              )}
            </div>
            <Link to="/about" className="text-white hover:text-gray-200 font-medium">{t('nav.about')}</Link>
            <Link to="/location" className="text-white hover:text-gray-200 font-medium">{t('nav.location')}</Link>
            <Link to="/contact" className="text-white hover:text-gray-200 font-medium">{t('nav.contact')}</Link>
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className="text-sm text-gray-200 hover:text-white font-medium"
            >
              {i18n.language === 'sv' ? 'EN' : 'SV'}
            </button>
            
            <button
              className="md:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span className="sr-only">Open menu</span>
              <div className="w-6 h-6 flex flex-col justify-center">
                <span className="block w-full h-0.5 bg-white mb-1"></span>
                <span className="block w-full h-0.5 bg-white mb-1"></span>
                <span className="block w-full h-0.5 bg-white"></span>
              </div>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link to="/" className="block px-3 py-2 text-white font-medium">{t('nav.home')}</Link>
              {serviceLinks.map(({ to, label }) => (
                <Link key={to} to={to} className="block px-3 py-2 text-white font-medium">{label}</Link>
              ))}
              <Link to="/about" className="block px-3 py-2 text-white font-medium">{t('nav.about')}</Link>
              <Link to="/location" className="block px-3 py-2 text-white font-medium">{t('nav.location')}</Link>
              <Link to="/contact" className="block px-3 py-2 text-white font-medium">{t('nav.contact')}</Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
